"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletsBar = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var config_1 = require("../../../../_staging/dashboard/fluidLayout/config");
var LayoutResizeContext_1 = require("../../LayoutResizeContext");
var Bullet_1 = require("./Bullet");
var BULLETS_COUNT = config_1.DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT + 1;
function BulletsBar() {
    var widthResizingStatus = LayoutResizeContext_1.useResizeWidthStatus();
    if (!widthResizingStatus.isResizingWidth) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "gd-resize-bullets-bar" }, tslib_1.__spread(Array(BULLETS_COUNT)).map(function (_, index) { return (react_1.default.createElement(Bullet_1.Bullet, { key: index, index: index, isInitial: widthResizingStatus.initialIndex === index, isCurrent: widthResizingStatus.currentIndex === index })); })));
}
exports.BulletsBar = BulletsBar;
//# sourceMappingURL=BulletsBar.js.map